import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {

	init() {

		function ElasticGridScrollMagic( container ) {

			var rows = container.querySelectorAll('.elasticGrid__row');

			var controller = new ScrollMagic.Controller();

			rows.forEach( function( row,index ) {

				new ScrollMagic.Scene({triggerElement: row, triggerHook: 0.9 })
					// trigger animation by adding a css class
					.setClassToggle(row, "backToPosition")
					// .addIndicators({name: "- ElasticGrid "+index}) // add indicators (requires plugin)
					.addTo(controller)
					.offset(1);

			});

		}

		var container = document.querySelectorAll('.elasticGrid')

		if( container.length > 0 ) {

			container.forEach( function( box, index ) {

				ElasticGridScrollMagic( box );

			});

		}

	},
	finalize(){

	}

}